/* eslint-disable */
<template id="NewPage">
  <div class="container">
    <div class="bg">
      <!-- <img src="../assets/bg.png" class="bgimg" /> -->
      <div class="bgtop">
        <div class="bgtop-left"></div>
        <div v-if="!hasLogin" class="bgtop-right-1" @click="showLoginAlert" style="cursor:pointer"></div>
        <div v-else class="bgtop-right-2" @click.stop="toggleTanchuang" style="cursor:pointer">
          <div v-if="showTanchuang" class="tanchuangbg" @click.stop>
            <div class="tanchuangbg-m">
              <div class="tanchuangbg-message">アカウント：</div>
              <div class="tanchuangbg-message-1">{{ userInfo.account || '' }}</div>
            </div>
            <div class="tanchuangbg-exit" @click.stop="showExitConfirm = true"></div>
          </div>
        </div>
      </div>

      <div class="bgcen" style="overflow:hidden; position:relative;">
        <div style="width:100%;height:100%;">
          <img :src="banners[currentBanner]" style="width:100%;height:100%;object-fit:cover;" />
        </div>
        <!-- 圆点指示器 -->
        <div style="position:absolute; left:50%; bottom:20px; transform:translateX(-50%); display:flex; gap:12px;">
          <span v-for="(item, idx) in banners" :key="idx" @click="setBanner(idx)" :style="{
            display: 'inline-block',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            background: currentBanner === idx ? '#fff' : 'rgba(255,255,255,0.4)',
            border: '2px solid #fff',
            cursor: 'pointer'
          }"></span>
        </div>
      </div>
      <div class="bg-m">
      <div class="bg-left">
        <div class="bg-left-kvbg"></div>
        <div class="bg-left-kvbg-1"></div>
        <div class="bg-left-kvbg-2"></div>
        <div class="bg-left-icon"></div>
        <div>
          <div class="custom-select" @click="toggleServerView">
            <span class="selected-text">{{ serverName || 'キャラを選択してください' }}</span>
            <span class="dropdown-icon"></span>
            <div v-show="showServers" class="dropdown-list">
              <div v-for="(i, index) in serverList" :key="index" @click.stop="changeServer(index)">
                {{ i.name || '' }}
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px;">
          <div class="custom-select" @click="toggleRoleView">
            <span class="selected-text">{{ roleName || 'キャラを選択してください' }}</span>
            <span class="dropdown-icon"></span>
            <div v-show="showRoles" class="dropdown-list">
              <div v-for="(role, i) in roleList" :key="i" @click.stop="changeRole(i)">
                {{ role.name || '' }}
              </div>
            </div>
          </div>
        </div>
        <div class="bg-left-login" @click="showLoginAlert" v-show="!hasLogin"></div>
      </div>
      <div class="bg-right">
        <div class="bg-right-top"></div>
        <div class="bg-right-zhifu"></div>

        <div class="bg-right-zhifu-list">
          <div v-for="(payment, index) in  gameInfo.payments" :key="index" class="bg-right-zhifu-list-item"
            @click="selPayment(index)">
            <img :src="getPaymentImg(index, payment.key)" />
          </div>
        </div>



        <div class="bg-right-shangpin-T"></div>
        <div class="bg-right-zuanshi-T" v-show="zuanshiList.length > 0"></div>

        <div class="bg-right-zuanshi-list" v-show="zuanshiList.length > 0">
          <div v-for="(zuanshi, index) in zuanshiList" :key="zuanshi.key" class="bg-right-zuanshi-list-item"
            @click="selProduct(zuanshi, index)" v-show="zuanshi.show">
            <img :src="zuanshi.bg" class="bg-right-zuanshi-list-item-bg" />
            <!-- <img v-show="zuanshi.icon == 1" src="../assets/pay/web-limit.png" class="bg-right-zuanshi-list-item-web" />
            <img v-show="zuanshi.icon == 2" src="../assets/pay/time-limit.png" class="bg-right-zuanshi-list-item-time" /> -->
            <div class="bg-right-zuanshi-1-2">
              <!-- <div>通常還元{{ zuanshi.rebate }}%</div> -->
               <div>公式チャージ超お得！</div>
            </div>
            <div class="bg-right-zuanshi-1-3">ダイヤ {{ zuanshi.diamond + zuanshi.b_diamond }}個</div>
            <div class="bg-right-zuanshi-1-4">有料ダイヤ{{ zuanshi.diamond }}個＋おまけ{{ zuanshi.b_diamond }}個</div>
            <div class="bg-right-zuanshi-1-5"
              :style="zuanshi.type == selObj.productType && index == selObj.productIndex ? 'background-image:url(' + require('../assets/btn-1.png') + ');background-size:cover;' : ''"
              @click.stop="pay(zuanshi, index)" style="cursor:pointer;">
              <div class="bg-right-zuanshi-1-5-1">{{ zuanshi.price }}円</div>
            </div>
          </div>
        </div>


        <div class="bg-right-xianjingquan-T">
          【現金券】は【金券】に名称が変更されました。なお、機能やご利用条件に変更は一切ございません
        </div>

        <div class="bg-right-xianjinhome-list">
          <div v-for="(zuanshi, index) in xianjinList" :key="index" class="bg-right-xianjinhome-list-item"
            @click="selProduct(zuanshi, index)" v-show="zuanshi.show">
            <img :src="zuanshi.bg" class="bg-right-xianjinhome-list-item-bg" />
            <!-- <img v-show="zuanshi.icon == 1" src="../assets/pay/web-limit.png" class="bg-right-xianjinhome-list-item-web" />
            <img v-show="zuanshi.icon == 2" src="../assets/pay/time-limit.png" 
              class="bg-right-xianjinhome-list-item-time" />-->

            <div class="bg-right-xianjinhome-1-2">
              <!-- <div>通常還元{{ zuanshi.rebate }}%</div> -->
               <div v-show="zuanshi.sub_type == 0">公式チャージ超お得！</div>
               <div v-show="zuanshi.sub_type == 1">ボーナス{{ zuanshi.rebate }}%</div>
            </div>
            <div class="bg-right-xianjinhome-1-3">{{ zuanshi.voucher }}金券</div>
            <div class="bg-right-xianjinhome-1-4" v-show="zuanshi.sub_type == 0">おまけ有料ダイヤ{{zuanshi.b_diamond}}個!</div>
            <div class="bg-right-xianjinhome-1-4" v-show="zuanshi.sub_type == 1">追加ギフト{{zuanshi.b_diamond}}枚</div>
            <div class="bg-right-xianjinhome-1-5"
              :style="zuanshi.type == selObj.productType && index == selObj.productIndex ? 'background-image:url(' + require('../assets/btn-1.png') + ');background-size:cover;' : ''"
              @click.stop="pay(zuanshi, index)" style="cursor:pointer;">
              <div class="bg-right-xianjinhome-1-5-1">{{ zuanshi.price }}円</div>
            </div>

          </div>
        </div>


        <div class="bg-right-xianjinhome-picture">
          <!-- <img src="../assets/illustrate.png" @click="showXianjinshuoming = true" /> -->
        </div>
        <!-- 现金券说明弹窗 -->
        <div v-if="showXianjinshuoming" class="xianjinshuoming-mask" @click="showXianjinshuoming = false">
          <div class="xianjinshuoming-content" @click.stop>
            <img :src="require('../assets/xianjinshuoming.png')" alt="金券说明"
              style="width:624px;height:677px;display:block;" />
            <img :src="require('../assets/close.png')" alt="关闭" class="xianjinshuoming-close"
              @click="showXianjinshuoming = false"
              style="width:53px;height:52px;display:block;margin:32px auto 0 auto;cursor:pointer;" />
          </div>
        </div>
      </div>
      </div>
      <div class="bg-bottom">
        <div>
          <p>チャージ説明：</p>
          <p>１．『エターナルドラグーン：焔の誓い』のチャージは、すべて公式サイトに統一されております。iOSおよびAndroidをご利用のお客様、いずれにも対応しております。</p>
          <p>２．キャラクターがログインできるかどうかと購入希望の商品を確認してから行ってください。また、ゲストアカウントは公式サイトをご利用できませんので、ご注意ください。</p>
          <p>３. 本サイトでご購入いただいた商品は、ゲーム内に直接配布されます。ご購入後のおまけ金券や追加報酬は、ゲーム内のメールにてご確認ください。ご購入前に必ずキャラクター情報をご確認のうえ、内容に誤りがないかご確認ください。</p>
          <p>４．金券は1金券＝1円の比率でチャージ商品を支払うことができます。金券を購入する段階では、公式サイトで「チャージ」という行為に認定され、公式サイトで開催するチャージイベントに参加できます。しかし、ゲーム内「チャージ」という行為に認定されません、累計チャージやチャージ還元などのチャージイベントに参加できません。</p>
          <p>５．決済画面が表示されない場合は、ポップアップブロック機能が有効になっている可能性がございます。設定をご確認のうえ、再度お試しください。</p>
          <p>６．デジタルコンテンツの特性上、返品やキャンセルはお受けしておりません。</p>
          <p>７．ご購入後、商品の配布に時間がかかる場合がございます。恐れ入りますが、しばらくお待ちください。ご不明な点がございましたら、お気軽にお問い合わせください：E-mail: htkh.cskh@gmail.com</p>
        </div>
        <!-- <a class="footer-link footer-link-1" href="https://www.eternaldragoon.com/ios-user-agreement.html"
          target="_blank"></a>
        <a class="footer-link footer-link-2" href="https://www.eternaldragoon.com/ios-privacy-policy.html"
          target="_blank"></a>
        <a class="footer-link footer-link-3"
          href="https://www.eternaldragoon.com/ios-specifed-commercial-transaction-law.html" target="_blank"></a>
        <a class="footer-link footer-link-4" href="https://www.eternaldragoon.com/ios-fund-settlement-method.html"
          target="_blank"></a> -->
      </div>
      <div class="bbb">
        <div>@ JUYOU INFORMATION TECHNOLOGY CO., LIMITED All Rights Reserved</div>
        <div class="bbb-1">
          <div style="cursor: pointer;" @click="toUrl('https://www.eternaldragoon.com/ios-user-agreement.html')">
            利用規約
          </div>
          <div class="bbb-11">|</div>
          <div style="cursor: pointer;" @click="toUrl('https://www.eternaldragoon.com/ios-privacy-policy.html')">プライバシーポリシー</div>
          <div class="bbb-11">|</div>
          <div style="cursor: pointer;" @click="toUrl('https://www.eternaldragoon.com/ios-specified-commercial-transaction-law.html')"> 特定商取引法</div>
          <div class="bbb-11">|</div>
          <div style="cursor: pointer;" @click="toUrl('https://www.eternaldragoon.com/ios-fund-settlement-method.html')">資金決済法</div>
        </div>
      </div>
    </div>

    <!-- 退出确认弹窗和遮罩 -->
    <div v-if="showExitConfirm" class="exit-modal-mask" @click="showExitConfirm = false">
      <div class="exit-modal-content" @click.stop style="width:569px; height:213px;">
        <img :src="require('../assets/tanchuangexit/bg-exit.png')" alt="退出确认" />
        <img :src="require('../assets/tanchuangexit/cancel2.png')" alt="取消"
          style="position:absolute;top:137px;left:65px;width:198px;height:48px;cursor:pointer;"
          @click="showExitConfirm = false" />
        <img :src="require('../assets/tanchuangexit/confirm.png')" alt="确认"
          style="position:absolute;top:137px;left:292px;width:198px;height:48px;cursor:pointer;"
          @click="logout2" />
      </div>
    </div>

    <!-- 登录信息填写弹窗和遮罩 -->
    <div v-if="showLoginDialog" class="exit-modal-mask" @click="showLoginDialog = false">
      <!-- 关闭按钮，位于弹窗外部左上角 -->
      <img class="login-close-btn" :src="require('../assets/denglutanchuang/close.png')" alt="关闭"
        @click.stop="showLoginDialog = false" />
      <div class="exit-modal-content login-dialog" @click.stop>
        <img class="login-dialog-bg" :src="require('../assets/denglutanchuang/bg.png')" alt="登录信息" />
        <!-- 账号输入框 -->
        <div class="login-account-box">
          <img class="login-input-bg" :src="require('../assets/denglutanchuang/juxing-2.png')" />
          <input class="login-input" v-model="loginAccount" :placeholder="'アカウントを入力してください'" />
        </div>
        <!-- 密码输入框 -->
        <div class="login-password-box">
          <img class="login-input-bg" :src="require('../assets/denglutanchuang/juxing-2.png')" />
          <input class="login-input" v-model="loginPassword" :placeholder="'パスワードを入力してください'" type="password" />
        </div>
        <!-- 同意协议 -->
        <div class="login-agree-row">
          <div class="login-agree-checkbox" @click="loginAgree = !loginAgree">
            <img class="login-agree-checkbox-bg" :src="require('../assets/denglutanchuang/weixuanze.png')" />
            <img v-if="loginAgree" class="login-agree-checkbox-checked"
              :src="require('../assets/denglutanchuang/dagou.png')" />
          </div>
          <span class="login-agree-text">
            <a href="https://www.eternaldragoon.com/ios-privacy-policy.html" target="_blank"
              style="color:inherit;text-decoration:underline;">プライバシーポシー</a>と<a
              href="https://www.eternaldragoon.com/ios-user-agreement.html" target="_blank"
              style="color:inherit;text-decoration:underline;">利用規約</a>に同意
          </span>
        </div>
        <!-- 登录按钮 -->
        <img class="login-btn" :src="require('../assets/denglutanchuang/sign-in-btn.png')" alt="登录"
          @click="login" />
        <!-- 其他方式图片 -->
        <img class="login-other-methods" :src="require('../assets/denglutanchuang/qita.png')" alt="其他方式" />
        <!-- 三方登录图标包裹在一个div里 -->
        <div class="login-third-row">
          <img v-show="thirdLogin.fb" @click="fbLogin" class="login-icon-fb" :src="require('../assets/denglutanchuang/fb.png')" alt="Facebook" />
          <img id="appleid-signin" v-show="thirdLogin.apple" class="login-icon-apple" :src="require('../assets/denglutanchuang/ios.png')" alt="Apple" />
          <div v-show="thirdLogin.google" @click="googleLogin" class="login-icon-google">
            <img  :src="require('../assets/denglutanchuang/google.png')" alt="Google" />
          </div>
          <div id="gg"></div>
        </div>
        <!-- 登录错误提示弹窗 -->
        <div v-if="showLoginError" class="login-error-popup">
          <img class="login-error-bg" :src="require('../assets/denglutanchuang/beiyong-bg.png')" />
          <img v-if="loginErrorType === 'fail'" class="login-error-img"
            :src="require('../assets/denglutanchuang/denglushibai.png')" />
          <img v-else-if="loginErrorType === 'id'" class="login-error-img"
            :src="require('../assets/denglutanchuang/idcuowu2.png')" />
          <img v-else-if="loginErrorType === 'pwd'" class="login-error-img"
            :src="require('../assets/denglutanchuang/mimacuowu.png')" />
        </div>
      </div>
    </div>



    <!-- 确认商品弹窗 -->
    <div v-if="showConfirmDialog" class="exit-modal-mask" @click="closeConfirmDialog">
      <div class="exit-modal-content confirm-dialog" @click.stop>
        <img class="confirm-dialog-bg" :src="require('../assets/querenshangpin/bg.png')" alt="确认商品" />
        <!-- 角色信息 -->
        <div class="confirm-row confirm-row-role">
          <span class="confirm-label">キャラクター：</span>
          <span class="confirm-value confirm-value-right">{{ serverName + ' ' + roleName }}</span>
        </div>
        <!-- 分割线图片 -->
        <img class="confirm-divider" :src="require('../assets/querenshangpin/xian.png')" alt="分割线" />
        <!-- 赚入内容 -->
        <div class="confirm-row confirm-row-content">
          <span class="confirm-label" v-show="showXianjinNew">購入金券（枚）：</span>
          <span class="confirm-label" v-show="!showXianjinNew">購入内容：</span>
          <span class="confirm-value confirm-value-right">{{ payProductName }}</span>
        </div>
        <!-- おまけ -->
        <div class="confirm-row confirm-row-bonus">
          <span class="confirm-label" v-show="showXianjinNew">合計金券（枚）：</span>
          <span class="confirm-label" v-show="!showXianjinNew">おまけ：</span>
          <span class="confirm-value confirm-value-right">{{ payRebateName }}</span>
        </div>
        <!-- 年龄确认 -->
        <div class="confirm-row confirm-row-age">
          <span class="confirm-label">年齢確認</span>
          <span class="confirm-value confirm-value-right" @click.stop="toggleAgeDropdown">
            <span class="confirm-age-selected">{{ ageShortOptions[selectedAge] }}</span>
            <img class="confirm-arrow" :src="require('../assets/querenshangpin/jiantou.png')" />
          </span>
        </div>
        <!-- 支付方式 -->
        <div class="confirm-row confirm-row-paytype">
          <span class="confirm-paytype-label">支払方法：</span>
          <div class="confirm-paytype-img" >
            <img :src="payPaymentIcon" alt="支払方法" />
          </div>
          <span class="confirm-paytype-name">{{ payPaymentName }}</span>
        </div>
        <!-- 合计 -->
        <div class="confirm-total-row">
          <!-- <span v-show="showXianjinNew">金額</span> -->
          <span v-show="!showXianjinNew">合计</span>
          <span class="confirm-total-amount">¥{{ payPrice }}</span>
        </div>
        <!-- 赚入确认按钮 -->
        <img @click="callPay" class="confirm-btn" :src="require('../assets/querenshangpin/btn.png')" alt="赚入确认" />
        <!-- 下拉区整体 -->
        <div v-if="ageDropdownVisible" class="confirm-dropdown-bg">
          <img class="confirm-dropdown-img" :src="require('../assets/querenshangpin/xialakuang.png')" />
          <!-- 选中显示区 -->
          <div class="confirm-selected-row">
            <span>{{ ageOptions[selectedAge] }}</span>
            <img class="confirm-selected-arrow" :src="require('../assets/querenshangpin/xiala.png')"
              @click.stop="toggleDropdownList" />
          </div>
          <!-- 下拉内容 -->
          <div v-if="dropdownListVisible" class="confirm-dropdown-list">
            <div class="confirm-dropdown-item" @click="selectAge(0)">
              <span>18歳(上限ない)</span>
              <img v-if="selectedAge === 0" class="confirm-dropdown-check"
                :src="require('../assets/querenshangpin/dagou.png')" />
            </div>
            <div class="confirm-dropdown-item" @click="selectAge(1)">
              <span>16～17歳（1ヶ月20,000円まで）</span>
              <img v-if="selectedAge === 1" class="confirm-dropdown-check"
                :src="require('../assets/querenshangpin/dagou.png')" />
            </div>
            <div class="confirm-dropdown-item" @click="selectAge(2)">
              <span>~15歳（1ヶ月5000円まで）</span>
              <img v-if="selectedAge === 2" class="confirm-dropdown-check"
                :src="require('../assets/querenshangpin/dagou.png')" />
            </div>
          </div>
        </div>
        <!-- 底部提示 -->
        <div class="confirm-bottom-tip">
          為替レートの変動や銀行手数料が最終の支払額に影響する場合があります。
        </div>
        <!-- 关闭按钮，位于弹窗下方，样式同登录弹窗 -->
        <img class="confirm-close-btn" :src="require('../assets/denglutanchuang/close.png')" alt="关闭"
          @click.stop="closeConfirmDialog" />
      </div>
    </div>
    <div class="loading" v-if="loading">
        <div class="mask"></div>
        <div class="loading-box">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>

  </div>
</template>
 
<style lang="scss" src="./Pay.scss" scoped></style>

<script>
import component from './Pay.js'
export default component
</script>
